import { post } from 'app/utils/axios/kheti'
import { Livestock } from "../models/farmer";

const updateFarmerLivestocks = async (
  farmerId: string | number,
  livestocks: Livestock[]
) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/livestock`;
    await post(url, { livestocks: livestocks });
    return true;
  } catch (e) {
    return false;
  }
};

export default updateFarmerLivestocks;
